export default __webpack_public_path__ + "static/greendjinn-1de25f598177412af1c0e21a2e07cd20.png";